// extracted by mini-css-extract-plugin
export var bar = "BookingSearchBox-module--bar--a94e9";
export var cruises = "BookingSearchBox-module--cruises--4b789";
export var flights = "BookingSearchBox-module--flights--afe7e";
export var hotels = "BookingSearchBox-module--hotels--8580a";
export var packages = "BookingSearchBox-module--packages--18761";
export var placeholder = "BookingSearchBox-module--placeholder--7f7cc";